import { render, staticRenderFns } from "./TrainingDemandCourses.vue?vue&type=template&id=6fe8355c&scoped=true"
import script from "./TrainingDemandCourses.vue?vue&type=script&lang=js"
export * from "./TrainingDemandCourses.vue?vue&type=script&lang=js"
import style0 from "./TrainingDemandCourses.vue?vue&type=style&index=0&id=6fe8355c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe8355c",
  null
  
)

export default component.exports